// ─── Shared audit log entry (used across CP, RL, NR workflows) ──────────────

export interface AuditLogEntry {
  id: number;
  timestamp: string;
  actionType: string;
  actorName: string;
  details: string;
  /** Human-readable description shown in the audit log table. Populated by case-specific services. */
  displayDescription?: string | null;
  /** Human-readable message extracted from the Details JSON. Only present for CP events. */
  message?: string | null;
}
